import React from "react";
import ReactDOM from "react-dom";

const Modal = (props: any) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={props.onDismiss}>
      <div className="bg-background rounded-lg shadow-lg max-w-lg w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="px-6 py-4 border-b font-semibold text-lg">{props.title}</div>
        <div className="px-6 py-4">{props.content}</div>
        <div className="px-6 py-4 border-t flex justify-end gap-2">{props.actions}</div>
      </div>
    </div>,
    document.querySelector("#modal")!
  );
};

export default Modal;
